{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Wklej",
    "pasteAsPlaintext": "Wklej jako zwykły tekst",
    "pasteCharts": "Wklej wykresy",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Zaznacz wszystko",
    "multiSelect": "Dodaj element do zaznaczenia",
    "moveCanvas": "Przesuń obszar roboczy",
    "cut": "Wytnij",
    "copy": "Kopiuj",
    "copyAsPng": "Kopiuj do schowka jako plik PNG",
    "copyAsSvg": "Kopiuj do schowka jako plik SVG",
    "copyText": "Kopiuj do schowka jako tekst",
    "copySource": "Kopiuj źródło do schowka",
    "convertToCode": "Skonwertuj na kod",
    "bringForward": "Przesuń warstwę wyżej",
    "sendToBack": "Przenieś na spód",
    "bringToFront": "Przenieś na wierzch",
    "sendBackward": "Przenieś warstwę niżej",
    "delete": "Usuń",
    "copyStyles": "Kopiuj style",
    "pasteStyles": "Wklej style",
    "stroke": "Kreska",
    "changeStroke": "Zmień kolor kreski",
    "background": "Tło",
    "changeBackground": "Zmień kolor tła",
    "fill": "Wypełnienie",
    "strokeWidth": "Szerokość kreski",
    "strokeStyle": "Styl kreski",
    "strokeStyle_solid": "Pełny",
    "strokeStyle_dashed": "Linia przerywana",
    "strokeStyle_dotted": "Kropkowany",
    "sloppiness": "Styl kreski",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Przezroczystość",
    "textAlign": "Wyrównanie tekstu",
    "edges": "Krawędzie",
    "sharp": "Ostry",
    "round": "Zaokrąglij",
    "arrowheads": "Groty",
    "arrowhead_none": "Brak",
    "arrowhead_arrow": "Strzałka",
    "arrowhead_bar": "Kreska",
    "arrowhead_circle": "Koło",
    "arrowhead_circle_outline": "Koło (puste)",
    "arrowhead_triangle": "Trójkąt",
    "arrowhead_triangle_outline": "Trójkąt (pusty)",
    "arrowhead_diamond": "Romb",
    "arrowhead_diamond_outline": "Romb (pusty)",
    "arrowhead_crowfoot_many": "Notacja Martina (wiele)",
    "arrowhead_crowfoot_one": "Notacja Martina (jeden)",
    "arrowhead_crowfoot_one_or_many": "Notacja Martina (jeden lub wiele)",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "Więcej opcji",
    "cardinality": "",
    "arrowtypes": "Typ strzałki",
    "arrowtype_sharp": "Ostra strzałka",
    "arrowtype_round": "Zaokrąglona strzałka",
    "arrowtype_elbowed": "Łamana strzałka",
    "fontSize": "Rozmiar tekstu",
    "fontFamily": "Krój pisma",
    "addWatermark": "Dodaj \"Zrobione w Excalidraw\"",
    "handDrawn": "Odręczny",
    "normal": "Normalny",
    "code": "Kod",
    "small": "Mały",
    "medium": "Średni",
    "large": "Duży",
    "veryLarge": "Bardzo duży",
    "solid": "Pełne",
    "hachure": "Linie",
    "zigzag": "Zygzak",
    "crossHatch": "Zakreślone",
    "thin": "Cienkie",
    "bold": "Pogrubione",
    "left": "Do lewej",
    "center": "Do środka",
    "right": "Do prawej",
    "extraBold": "Ekstra pogrubione",
    "architect": "Dokładny",
    "artist": "Artystyczny",
    "cartoonist": "Rysunkowy",
    "fileTitle": "Nazwa pliku",
    "colorPicker": "Paleta kolorów",
    "canvasColors": "Używane na płótnie",
    "canvasBackground": "Kolor dokumentu",
    "drawingCanvas": "Obszar roboczy",
    "clearCanvas": "Wyczyść płótno",
    "layers": "Warstwy",
    "actions": "Akcje",
    "language": "Język",
    "liveCollaboration": "Współpraca w czasie rzeczywistym...",
    "duplicateSelection": "Powiel",
    "untitled": "Bez tytułu",
    "name": "Nazwa",
    "yourName": "Twoje imię",
    "madeWithExcalidraw": "Zrobione w Excalidraw",
    "group": "Zgrupuj wybrane",
    "ungroup": "Rozgrupuj wybrane",
    "collaborators": "Współtwórcy",
    "you": "",
    "toggleGrid": "Przełącz widoczność siatki",
    "loadingScene": "Wczytywanie sceny…",
    "loadScene": "Wczytaj scenę z pliku",
    "align": "Wyrównaj",
    "alignTop": "Wyrównaj do góry",
    "alignBottom": "Wyrównaj do dołu",
    "alignLeft": "Wyrównaj do lewej",
    "alignRight": "Wyrównaj do prawej",
    "centerVertically": "Wyśrodkuj w pionie",
    "centerHorizontally": "Wyśrodkuj w poziomie",
    "distributeHorizontally": "Rozłóż poziomo",
    "distributeVertically": "Rozłóż pionowo",
    "flipHorizontal": "Odwróć w poziomie",
    "flipVertical": "Odwróć w pionie",
    "viewMode": "Tryb widoku",
    "share": "Udostępnij",
    "showStroke": "Pokaż próbnik kolorów obrysu",
    "showBackground": "Pokaż próbnik koloru tła",
    "showFonts": "Pokaż selektor czcionek",
    "toggleTheme": "Przełącz motyw jasny / ciemny",
    "theme": "Motyw",
    "decreaseFontSize": "Zmniejsz rozmiar czcionki",
    "increaseFontSize": "Zwiększ rozmiar czcionki",
    "unbindText": "Odłącz tekst od kontenera",
    "bindText": "Połącz tekst z kontenerem",
    "createContainerFromText": "Zawijaj tekst w kontenerze",
    "link": {
      "edit": "Edytuj łącze",
      "editEmbed": "Edytuj osadzalne łącze",
      "create": "Dodaj link",
      "label": "Łącze",
      "labelEmbed": "Podlinkuj i osadź",
      "empty": "Brakujący link",
      "hint": "Wpisz lub wklej swój link tutaj",
      "goToElement": "Przejdź do elementu docelowego"
    },
    "lineEditor": {
      "edit": "Edytuj linię",
      "editArrow": "Edytuj strzałkę"
    },
    "polygon": {
      "breakPolygon": "Przerwij wielokąt",
      "convertToPolygon": "Przekształć w wielokąt"
    },
    "elementLock": {
      "lock": "Zablokuj",
      "unlock": "Odblokuj",
      "lockAll": "Zablokuj wszystko",
      "unlockAll": "Odblokuj wszystko"
    },
    "sidebarLock": "Panel boczny zawsze otwarty",
    "selectAllElementsInFrame": "Zaznacz wszystkie elementy w ramce",
    "removeAllElementsFromFrame": "Usuń wszystkie elementy z ramki",
    "eyeDropper": "Wybierz kolor z płótna",
    "followUs": "Obserwuj nas",
    "discordChat": "Czat Discorda",
    "zoomToFitViewport": "Dopasuj widok do ekranu",
    "zoomToFitSelection": "Dopasuj widok do zaznaczenia",
    "zoomToFit": "Dopasuj widok do całej zawartości",
    "installPWA": "Zainstaluj Excalidraw lokalnie (PWA)",
    "autoResize": "Włącz automatyczne zmiany rozmiaru tekstu",
    "imageCropping": "Przycinanie obrazu",
    "unCroppedDimension": "Nieprzycięty wymiar",
    "copyElementLink": "Kopiuj link do obiektu",
    "linkToElement": "Link do obiektu",
    "wrapSelectionInFrame": "Owiń wybór w ramkę",
    "tab": "Tab",
    "shapeSwitch": "Wybór kształtu",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "Link do obiektu",
    "desc": "Kliknij kształt na obszarze roboczym lub wklej link.",
    "notFound": "Powiązany obiekt nie został znaleziony na płótnie."
  },
  "search": {
    "title": "Znajdź na płótnie",
    "noMatch": "Nie znaleziono pasujących elementów...",
    "singleResult": "wynik",
    "multipleResults": "wyniki",
    "placeholder": "Znajdź tekst na płótnie...",
    "frames": "Ramki",
    "texts": "Teksty"
  },
  "buttons": {
    "clearReset": "Wyczyść dokument i zresetuj kolor dokumentu",
    "exportJSON": "Eksportuj do pliku",
    "exportImage": "Eksportuj obraz...",
    "export": "Zapisz jako...",
    "copyToClipboard": "Skopiuj do schowka",
    "copyLink": "Kopiuj link",
    "save": "Zapisz do bieżącego pliku",
    "saveAs": "Zapisz jako",
    "load": "Otwórz",
    "getShareableLink": "Udostępnij",
    "close": "Zamknij",
    "selectLanguage": "Wybierz język",
    "scrollBackToContent": "Wróć do obszaru roboczego",
    "zoomIn": "Powiększ",
    "zoomOut": "Pomniejsz",
    "resetZoom": "Zresetuj powiększenie",
    "menu": "Menu",
    "done": "Gotowe",
    "edit": "Edytuj",
    "undo": "Cofnij",
    "redo": "Przywróć",
    "createNewRoom": "Utwórz nowy pokój",
    "fullScreen": "Pełny ekran",
    "darkMode": "Ciemny motyw",
    "lightMode": "Jasny motyw",
    "systemMode": "Motyw systemowy",
    "zenMode": "Tryb Zen",
    "objectsSnapMode": "Przyciąganie do obiektów",
    "exitZenMode": "Wyjdź z trybu Zen",
    "cancel": "Anuluj",
    "clear": "Wyczyść",
    "remove": "Usuń",
    "embed": "Przełącz osadzenie",
    "submit": "Prześlij",
    "confirm": "Zatwierdź",
    "embeddableInteractionButton": "Kliknij, aby wejść w interakcję"
  },
  "alerts": {
    "clearReset": "To spowoduje usunięcie wszystkiego z dokumentu. Czy chcesz kontynuować?",
    "couldNotCreateShareableLink": "Wystąpił błąd przy generowaniu linka do udostępniania.",
    "couldNotCreateShareableLinkTooBig": "Nie można utworzyć linku do udostępnienia: scena jest za duża",
    "couldNotLoadInvalidFile": "Nie udało się otworzyć pliku. Wybrany plik jest nieprawidłowy.",
    "importBackendFailed": "Wystąpił błąd podczas importowania pliku.",
    "cannotExportEmptyCanvas": "Najpierw musisz coś narysować, aby zapisać dokument.",
    "couldNotCopyToClipboard": "Nie udało się skopiować do schowka.",
    "decryptFailed": "Nie udało się odszyfrować danych.",
    "uploadedSecurly": "By zapewnić Ci prywatność, udostępnianie projektu jest zabezpieczone szyfrowaniem end-to-end, co oznacza, że poza tobą i osobą z którą podzielisz się linkiem, nikt nie ma dostępu do tego co udostępniasz.",
    "loadSceneOverridePrompt": "Wczytanie zewnętrznego rysunku zastąpi istniejącą zawartość. Czy chcesz kontynuować?",
    "collabStopOverridePrompt": "Zatrzymanie sesji nadpisze poprzedni, zapisany lokalnie rysunek. Czy jesteś pewien?\n\n(Jeśli chcesz zachować swój lokalny rysunek, po prostu zamknij zakładkę przeglądarki.)",
    "imageDoesNotContainScene": "Ten obraz nie zawiera żadnych informacji o scenie. Czy włączyłeś osadzanie sceny podczas eksportu?",
    "cannotRestoreFromImage": "Scena nie mogła zostać przywrócona z pliku obrazu",
    "invalidSceneUrl": "Nie udało się zaimportować sceny z podanego adresu URL. Jest ona wadliwa lub nie zawiera poprawnych danych Excalidraw w formacie JSON.",
    "invalidEncryptionKey": "Klucz szyfrowania musi składać się z 22 znaków. Współpraca na żywo jest wyłączona.",
    "collabOfflineWarning": "Brak połączenia z Internetem.\nTwoje zmiany nie zostaną zapisane!",
    "localStorageQuotaExceeded": "Przekroczono limit pamięci przeglądarki. Zmiany nie zostaną zapisane."
  },
  "errors": {
    "unsupportedFileType": "Nieobsługiwany typ pliku.",
    "imageInsertError": "Nie udało się wstawić obrazu. Spróbuj ponownie później...",
    "fileTooBig": "Plik jest zbyt duży. Maksymalny dozwolony rozmiar to {{maxSize}}.",
    "svgImageInsertError": "Nie udało się wstawić obrazu SVG. Znacznik SVG wygląda na nieprawidłowy.",
    "failedToFetchImage": "Nie udało się załadować obrazu.",
    "cannotResolveCollabServer": "Nie można połączyć się z serwerem współpracy w czasie rzeczywistym. Proszę odświeżyć stronę i spróbować ponownie.",
    "collabSaveFailed": "Nie udało się zapisać w bazie danych. Jeśli problemy nie ustąpią, zapisz plik lokalnie, aby nie utracić swojej pracy.",
    "collabSaveFailed_sizeExceeded": "Nie udało się zapisać w bazie danych — dokument jest za duży. Zapisz plik lokalnie, aby nie utracić swojej pracy.",
    "imageToolNotSupported": "Dodawanie obrazów jest wyłączone.",
    "brave_measure_text_error": {
      "line1": "Wygląda na to, że używasz przeglądarki Brave z włączonym ustawieniem <bold>Agressively Block Fingerprinting</bold>.",
      "line2": "Może to doprowadzić do złamania <bold>elementów tekstu</bold> na rysunkach.",
      "line3": "Zdecydowanie zalecamy wyłączenie tego ustawienia. Możesz wykonać <link>te kroki</link>, aby to zrobić.",
      "line4": "Jeśli wyłączenie tego ustawienia nie naprawia wyświetlania elementów tekstowych, zgłoś <issueLink>problem</issueLink> na naszym GitHubie lub napisz do nas na <discordLink>Discordzie</discordLink>"
    },
    "asyncPasteFailedOnRead": "Nie udało się wkleić (nie udało się odczytać ze schowka systemowego).",
    "asyncPasteFailedOnParse": "Nie udało się wkleić.",
    "copyToSystemClipboardFailed": "Nie udało się skopiować do schowka."
  },
  "toolBar": {
    "selection": "Zaznaczenie",
    "lasso": "Wybór lassem",
    "image": "Wstaw obraz",
    "rectangle": "Prostokąt",
    "diamond": "Romb",
    "ellipse": "Elipsa",
    "arrow": "Strzałka",
    "line": "Linia",
    "freedraw": "Rysuj",
    "text": "Tekst",
    "lock": "Zablokuj wybrane narzędzie",
    "penMode": "Tryb pióra — zapobiegaj dotknięciom",
    "link": "Dodaj/aktualizuj link dla wybranego kształtu",
    "eraser": "Gumka",
    "frame": "Ramka",
    "embeddable": "Osadzenie z internetu",
    "laser": "Wskaźnik laserowy",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Ręka (narzędzie do przesuwania)",
    "extraTools": "Więcej narzędzi",
    "convertElementType": "Przełącz typ kształtu"
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Prostokąt",
    "diamond": "Romb",
    "ellipse": "Elipsa",
    "arrow": "Strzałka",
    "line": "Linia",
    "freedraw": "Rysowanie odręczne",
    "text": "Tekst",
    "image": "Obraz",
    "group": "Grupa",
    "frame": "Ramka",
    "embeddable": "Osadzenie",
    "selection": "Zaznaczenie",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Narzędzia",
    "selectedShapeActions": "Wybrane narzędzie",
    "shapes": "Kształty"
  },
  "hints": {
    "dismissSearch": "Naciśnij {{shortcut}}, aby odrzucić wyszukiwanie",
    "canvasPanning": "Aby przesunąć płótno, przytrzymaj {{shortcut_1}} lub {{shortcut_2}} podczas przeciągania, albo użyj narzędzia ręki",
    "linearElement": "Naciśnij, aby zrobić punkt, przeciągnij, aby narysować linię",
    "arrowTool": "Kliknij, aby rozpocząć rysowanie wielu punktów; przeciągnij, aby narysować pojedynczą linię. Naciśnij ponownie {{shortcut}}, aby zmienić typ strzałki.",
    "arrowBindModifiers": "",
    "freeDraw": "Naciśnij i przeciągnij by rysować, puść kiedy skończysz",
    "text": "Wskazówka: możesz również dodać tekst klikając dwukrotnie gdziekolwiek za pomocą narzędzia zaznaczania",
    "embeddable": "Kliknij i przeciągnij, aby stworzyć osadzenie strony",
    "autoshape": "",
    "text_selected": "Kliknij dwukrotnie lub naciśnij {{shortcut}}, aby edytować tekst",
    "text_editing": "Naciśnij {{shortcut_1}} lub {{shortcut_2}}, aby zakończyć edycję",
    "linearElementMulti": "Kliknij ostatni punkt lub naciśnij {{shortcut_1}} lub {{shortcut_2}}, aby zakończyć",
    "lockAngle": "Możesz ograniczyć kąt, przytrzymując {{shortcut}}",
    "resize": "Możesz zachować proporcje, przytrzymując {{shortcut_1}} podczas zmiany rozmiaru;\nprzytrzymaj {{shortcut_2}}, aby zmienić rozmiar względem środka",
    "resizeImage": "Możesz dowolnie zmieniać rozmiar, przytrzymując {{shortcut_1}};\nprzytrzymaj {{shortcut_2}}, aby zmienić rozmiar względem środka.",
    "rotate": "Możesz ograniczyć kąty, przytrzymując {{shortcut}} podczas obracania",
    "toggleArrowhead": "",
    "lineEditor_info": "Przytrzymaj {{shortcut_1}} i kliknij dwukrotnie lub naciśnij {{shortcut_2}}, aby edytować punkty",
    "lineEditor_line_info": "Kliknij dwukrotnie lub naciśnij {{shortcut}}, aby edytować punkty",
    "lineEditor_pointSelected": "Naciśnij {{shortcut_1}}, aby usunąć punkty,\n{{shortcut_2}}, aby je powielić, lub przeciągnij, aby je przenieść",
    "lineEditor_nothingSelected": "Wybierz punkt do edycji (przytrzymaj {{shortcut_1}}, aby wybrać wiele punktów)\nlub przytrzymaj {{shortcut_2}} i kliknij myszą, aby dodać nowe punkty",
    "bindTextToElement": "Naciśnij {{shortcut}}, aby dodać tekst",
    "createFlowchart": "Naciśnij {{shortcut}}, aby utworzyć diagram",
    "deepBoxSelect": "Przytrzymaj {{shortcut}}, aby wybrać w obrębie grupy i zapobiec przeciągnięciu",
    "eraserRevert": "Przytrzymaj {{shortcut}}, aby przywrócić elementy oznaczone do usunięcia",
    "firefox_clipboard_write": "Ta funkcja może być włączona poprzez ustawienie flagi \"dom.events.asyncClipboard.clipboardItem\" na \"true\". Aby zmienić flagi przeglądarki w Firefox, odwiedź stronę \"about:config\".",
    "disableSnapping": "Przytrzymaj {{shortcut}} aby wyłączyć przyciąganie",
    "enterCropEditor": "Kliknij dwukrotnie obraz lub naciśnij {{shortcut}}, aby przyciąć obraz",
    "leaveCropEditor": "Kliknij obszar poza obrazem albo naciśnij {{shortcut_1}} lub {{shortcut_2}}, aby zakończyć przycinanie"
  },
  "canvasError": {
    "cannotShowPreview": "Nie można wyświetlić podglądu",
    "canvasTooBig": "Obszar roboczy może być za duży.",
    "canvasTooBigTip": "Wskazówka: spróbuj nieco zbliżyć najdalej wysunięte elementy."
  },
  "errorSplash": {
    "headingMain": "Wystąpił błąd. Spróbuj <button>odświeżyć stronę.</button>",
    "clearCanvasMessage": "Jeśli odświeżenie strony nie zadziałało, spróbuj <button>usunąć wszystko z dokumentu.</button>",
    "clearCanvasCaveat": " Pamiętaj tylko, że spowoduje to utratę całej twojej pracy ",
    "trackedToSentry": "Błąd o identyfikatorze {{eventId}} został zaraportowany w naszym systemie.",
    "openIssueMessage": "Szanujemy twoją prywatność i raport nie zawierał żadnych danych dotyczących tego nad czym pracowałeś, natomiast jeżeli jesteś w stanie podzielić się tym nad czym pracowałeś, prosimy o dodatkowy raport poprzez <button>nasze narzędzie do raportowania błędów.</button> Prosimy o dołączenie poniższej informacji poprzez skopiowanie jej i umieszczenie jej w zgłoszeniu na portalu GitHub.",
    "sceneContent": "Zawartość dokumentu:"
  },
  "shareDialog": {
    "or": "Lub"
  },
  "roomDialog": {
    "desc_intro": "Zaproś ludzi do wspólnego rysunku.",
    "desc_privacy": "Nie martw się, sesja jest szyfrowana end-to-end i w pełni prywatna. Nawet nasz serwer nie widzi co rysujesz.",
    "button_startSession": "Rozpocznij sesję",
    "button_stopSession": "Zakończ sesję",
    "desc_inProgressIntro": "Sesja współpracy na żywo właśnie się rozpoczęła.",
    "desc_shareLink": "Udostępnij ten link osobom, z którymi chcesz współpracować:",
    "desc_exitSession": "Zakończenie sesji spowoduje odłączenie ciebie od pokoju, ale nadal będziesz mógł lokalnie kontynuować pracę. Zauważ, że osoby z którymi współpracowałeś nadal będą mogły współpracować.",
    "shareTitle": "Dołącz do sesji współpracy na żywo w Excalidraw"
  },
  "errorDialog": {
    "title": "Wystąpił błąd"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "Zapisz na dysku",
    "disk_details": "Eksportuj dane sceny do pliku, z którego możesz importować później.",
    "disk_button": "Zapisz do pliku",
    "link_title": "Link do udostępnienia",
    "link_details": "Eksportuj jako link tylko do odczytu.",
    "link_button": "Wygeneruj link",
    "excalidrawplus_description": "Zapisz scenę do swojego obszaru roboczego Excalidraw+.",
    "excalidrawplus_button": "Eksportuj",
    "excalidrawplus_exportError": "W tej chwili nie można wyeksportować do Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Przeczytaj na naszym blogu",
    "click": "kliknięcie",
    "deepSelect": "Wybór w obrębie grupy",
    "deepBoxSelect": "Wybór w obrębie grupy i unikanie przeciągania",
    "createFlowchart": "Twórz diagram używając generycznych elementów",
    "navigateFlowchart": "Nawiguj diagram",
    "curvedArrow": "Zakrzywiona strzałka",
    "curvedLine": "Zakrzywiona linia",
    "documentation": "Dokumentacja",
    "doubleClick": "podwójne kliknięcie",
    "drag": "przeciągnij",
    "editor": "Edytor",
    "editLineArrowPoints": "Edytuj punkty linii/strzałki",
    "editText": "Edytuj tekst/dodaj etykietę",
    "github": "Znalazłeś problem? Prześlij",
    "howto": "Skorzystaj z instrukcji",
    "or": "lub",
    "preventBinding": "Zapobiegaj wiązaniu strzałek",
    "tools": "Narzędzia",
    "shortcuts": "Skróty klawiszowe",
    "textFinish": "Zakończ edycję (edytor tekstu)",
    "textNewLine": "Dodaj nowy wiersz (edytor tekstu)",
    "title": "Pomoc",
    "view": "Widok",
    "zoomToFit": "Powiększ, aby wyświetlić wszystkie elementy",
    "zoomToSelection": "Przybliż do zaznaczenia",
    "toggleElementLock": "Zablokuj/odblokuj zaznaczenie",
    "movePageUpDown": "Przesuń stronę w górę/w dół",
    "movePageLeftRight": "Przenieś stronę w lewo/prawo",
    "cropStart": "Przytnij obraz",
    "cropFinish": "Zakończ przycinanie obrazu"
  },
  "clearCanvasDialog": {
    "title": "Wyczyść płótno"
  },
  "imageExportDialog": {
    "header": "Eksportuj obraz",
    "label": {
      "withBackground": "Tło",
      "onlySelected": "Tylko wybrane",
      "darkMode": "Tryb ciemny",
      "embedScene": "Osadź scenę",
      "scale": "Skala",
      "padding": "Dopełnienie"
    },
    "tooltip": {
      "embedScene": "Dane sceny zostaną zapisane w eksportowanym pliku PNG/SVG tak, aby scena mogła zostać z niego przywrócona.\nZwiększy to rozmiar eksportowanego pliku."
    },
    "title": {
      "exportToPng": "Zapisz jako PNG",
      "exportToSvg": "Zapisz jako SVG",
      "copyPngToClipboard": "Skopiuj do schowka jako PNG"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Skopiuj do schowka"
    }
  },
  "encrypted": {
    "tooltip": "Twoje rysunki są zabezpieczone szyfrowaniem end-to-end, tak więc nawet w Excalidraw nie jesteśmy w stanie zobaczyć tego co tworzysz.",
    "link": "Wpis na blogu dotyczący szyfrowania end-to-end w Excalidraw"
  },
  "stats": {
    "angle": "Kąt",
    "shapes": "Kształty",
    "height": "Wysokość",
    "scene": "Scena",
    "selected": "Zaznaczenie",
    "storage": "Pamięć",
    "fullTitle": "Właściwości płótna i kształtu",
    "title": "Właściwości",
    "generalStats": "Ogólne",
    "elementProperties": "Właściwości kształtu",
    "total": "Łącznie",
    "version": "Wersja",
    "versionCopy": "Kliknij, aby skopiować",
    "versionNotAvailable": "Wersja niedostępna",
    "width": "Szerokość"
  },
  "toast": {
    "copyStyles": "Skopiowano style.",
    "copyToClipboard": "Skopiowano do schowka.",
    "copyToClipboardAsPng": "Skopiowano {{exportSelection}} do schowka jako PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "Skopiowano {{exportSelection}} do schowka jako SVG\n({{exportColorScheme}})",
    "fileSaved": "Zapisano plik.",
    "fileSavedToFilename": "Zapisano jako {filename}",
    "canvas": "płótno",
    "selection": "zaznaczenie",
    "pasteAsSingleElement": "Użyj {{shortcut}}, aby wkleić jako pojedynczy element,\nlub wklej do istniejącego edytora tekstu",
    "unableToEmbed": "Osadzenie tego linku jest obecnie niedozwolone. Zgłoś propozycję na portalu GitHub, aby dodać go do listy dozwolonych wyjątków",
    "unrecognizedLinkFormat": "Osadzony link ma niewłaściwy format. Spróbuj wkleić całą zawartość pola \"embed\" z oryginalnej strony.",
    "elementLinkCopied": "Łącze skopiowane do schowka"
  },
  "colors": {
    "transparent": "Przezroczysty",
    "black": "Czarny",
    "white": "Biały",
    "red": "Czerwony",
    "pink": "Różowy",
    "grape": "Winogronowy",
    "violet": "Fioletowy",
    "gray": "Szary",
    "blue": "Niebieski",
    "cyan": "Cyjanowy",
    "teal": "Turkusowy",
    "green": "Zielony",
    "yellow": "Żółty",
    "orange": "Pomarańczowy",
    "bronze": "Brązowy"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Czy zamiast tego chcesz przejść do Excalidraw+?",
      "menuHint": "Eksportuj, preferencje, języki..."
    },
    "defaults": {
      "menuHint": "Eksportuj, preferencje i więcej...",
      "center_heading": "Schematy uproszczone.",
      "toolbarHint": "Wybierz narzędzie i zacznij rysować!",
      "helpHint": "Skróty klawiaturowe i pomoc"
    }
  },
  "colorPicker": {
    "color": "Kolor",
    "mostUsedCustomColors": "Najczęściej używane kolory",
    "colors": "Kolory",
    "shades": "Odcienie",
    "hexCode": "Kod HEX",
    "noShades": "Brak dostępnych odcieni dla tego koloru",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Eksportuj jako obraz",
        "button": "Eksportuj jako obraz",
        "description": "Eksportuj zawartość sceny jako obraz z możliwością importowania."
      },
      "saveToDisk": {
        "title": "Zapisz na dysku",
        "button": "Zapisz na dysku",
        "description": "Eksportuj zawartość sceny jako plik z możliwością importowania."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Eksportuj do Excalidraw+",
        "description": "Zapisz scenę do swojego obszaru roboczego Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Wczytaj z pliku",
        "button": "Wczytaj z pliku",
        "description": "Wczytanie z pliku <bold>nadpisze istniejącą zawartość</bold>.<br></br>Możesz najpierw utworzyć kopię zapasową swojego rysunku, używając jednej z poniższych opcji."
      },
      "shareableLink": {
        "title": "Wczytaj z linku",
        "button": "Nadpisz moją zawartość",
        "description": "Wczytanie zewnętrznego pliku <bold>nadpisze istniejącą zawartość</bold>.<br></br>Możesz najpierw utworzyć kopię zapasową swojego rysunku, używając jednej z poniższych opcji."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Szybkie wyszukiwanie"
  },
  "fontList": {
    "badge": {
      "old": "stara"
    },
    "sceneFonts": "W tej scenie",
    "availableFonts": "Dostępne czcionki",
    "empty": "Nie znaleziono czcionek"
  },
  "userList": {
    "empty": "Nie znaleziono użytkowników",
    "hint": {
      "text": "Kliknij na użytkownika, aby obserwować",
      "followStatus": "Obserwujesz tego użytkownika",
      "inCall": "Użytkownik jest w trakcie połączenia głosowego",
      "micMuted": "Mikrofon użytkownik jest wyciszony",
      "isSpeaking": "Użytkownik przemawia"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Option",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Enter",
    "shift": "Shift",
    "spacebar": "Spacja",
    "delete": "Del",
    "mmb": "Kółko myszy"
  }
}
